import styled from "styled-components"

export const Toolbar = styled.div`
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .count {
        font-size: 13px;
        color: #4a5568;
        font-weight: 600;
    }

    .expandButtons {
        display: flex;
        gap: 6px;

        button {
            height: 34px;
            padding: 0 12px;
            border: 1px solid #cbd5e0;
            border-radius: 8px;
            background: #fff;
            color: #4a5568;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;

            &:active {
                background: #edf2f7;
            }
        }
    }
`

export const List = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const Card = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: border-color 0.15s, box-shadow 0.15s;

    &.selected {
        border-color: var(--blueColor1, #2563eb);
        box-shadow: 0 0 0 1px var(--blueColor1, #2563eb);
    }
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    cursor: pointer;

    &:active {
        background: #f8fafc;
    }
`

export const SelectCheck = styled.button`
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 2px solid #cbd5e0;
    background: #fff;
    color: transparent;
    font-size: 16px;
    font-weight: 800;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.checked {
        border-color: var(--blueColor1, #2563eb);
        background: var(--blueColor1, #2563eb);
        color: #fff;
    }
`

export const HeaderMain = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .addressRow {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .address {
        font-size: 17px;
        font-weight: 800;
        letter-spacing: 0.02em;
    }

    .metaRow {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        font-size: 12px;
        color: #718096;

        .count {
            font-weight: 700;
            color: #4a5568;
        }

        .link {
            color: #ec4899;
            font-weight: 700;
        }
    }
`

export const TypeBadge = styled.span`
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 800;
    padding: 2px 8px;
    border-radius: 6px;

    &.NORMAL {
        color: #16a34a;
        background: #f0fdf4;
    }
    &.INVENTORY {
        color: #2563eb;
        background: #eff6ff;
    }
`

export const Chevron = styled.div`
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a0aec0;
    font-size: 20px;
    transition: transform 0.2s;

    &.open {
        transform: rotate(180deg);
        color: #4a5568;
    }
`

export const IconButton = styled.button`
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    color: #94a3b8;
    font-size: 22px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
        background: #f1f5f9;
        color: #475569;
    }
    &:active {
        background: #e2e8f0;
    }
`

export const Body = styled.div`
    border-top: 1px solid #edf2f7;
`

export const Empty = styled.div`
    padding: 22px 14px;
    text-align: center;
    color: #a0aec0;
    font-size: 13px;
`

export const Products = styled.div`
    display: flex;
    flex-direction: column;
`

export const Product = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    border-bottom: 1px solid #f1f5f9;

    &:last-child {
        border-bottom: none;
    }

    .info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    .name {
        font-size: 14px;
        font-weight: 700;
        color: #1a202c;
        word-break: break-all;

        mark {
            background: #fef08a;
            color: inherit;
            padding: 0 1px;
            border-radius: 2px;
        }
    }

    .sub {
        font-size: 12px;
        color: #718096;
        word-break: break-all;

        .dot {
            margin: 0 5px;
            color: #cbd5e0;
        }

        mark {
            background: #fef08a;
            color: inherit;
            padding: 0 1px;
            border-radius: 2px;
        }
    }

    .qty {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-end;
    }

    .chip {
        font-size: 12px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 999px;
        white-space: nowrap;
        background: #edf2f7;
        color: #2d3748;

        &.box {
            background: #e6efff;
            color: #2563eb;
        }
    }
`
